(function () {
  'use strict';

  if (window.CzardBoot) return;

  var TASK_TIMEOUT = 12000;
  var GLOBAL_TIMEOUT = 15000;

  var STRICT_TIMEOUT = 60000;
  var strictPending = [];

  var total = 0;
  var settled = 0;
  var sealed = false;
  var pending = [];

  var entries = [];
  var totalWeight = 0;
  var lastProgress = 0;
  var startedAt = Date.now();

  function clamp01(v) {
    if (!(v > 0)) return 0;
    return v > 1 ? 1 : v;
  }

  function progress() {
    if (totalWeight <= 0) return sealed ? 1 : lastProgress;

    var sum = 0;
    for (var i = 0; i < entries.length; i++) {
      sum += entries[i].weight * entries[i].fraction;
    }
    var real = clamp01(sum / totalWeight);

    /* A task only reports 0 or 1 unless it calls report(), so a bar driven by
       the real figure alone sits at zero and then jumps — which reads as
       broken rather than slow. An eased floor creeps on its own, fast at
       first and flattening out, and real progress overtakes it as tasks land.

       Capped at 0.92: the bar must never claim to be finished on a timer,
       only on the work actually being done. */
    var t = (Date.now() - startedAt) / 1000;
    var creep = 0.92 * (1 - Math.exp(-t / 2.2));

    var p = clamp01(Math.max(real, creep));
    if (p > lastProgress) lastProgress = p;
    return lastProgress;
  }

  function add(promise, label, weight, strict) {
    if (sealed || !promise || typeof promise.then !== 'function') return promise;

    total++;
    var entry = { weight: weight > 0 ? weight : 1, fraction: 0 };
    entries.push(entry);
    totalWeight += entry.weight;

    var timer = 0;

    var guarded = new Promise(function (resolve) {
      var limit = strict ? STRICT_TIMEOUT : TASK_TIMEOUT;
      timer = setTimeout(function () {
        console.warn('[czard-boot] "' + (label || 'task') + '" timed out after ' + limit + 'ms');
        resolve();
      }, limit);

      promise.then(
        function () { resolve(); },
        function (err) {
          console.warn('[czard-boot] "' + (label || 'task') + '" failed:', err);
          resolve();
        }
      );
    }).then(function () {
      if (timer) clearTimeout(timer);
      entry.fraction = 1;
      settled++;
    });

    (strict ? strictPending : pending).push(guarded);
    return promise;
  }

  function task(label, weight, opts) {
    var strict = !!(opts && opts.strict);
    var resolveTask;
    var promise = new Promise(function (res) { resolveTask = res; });
    var entry = null;

    if (!sealed) {
      add(promise, label, weight, strict);
      entry = entries[entries.length - 1];
    }

    return {
      report: function (fraction) {
        if (!entry) return;
        var f = clamp01(fraction);
        if (f > entry.fraction) entry.fraction = f;
      },
      done: function () { resolveTask(); }
    };
  }

  /* ---- phase two ----
     Everything registered here runs only once the gate has opened. It is the
     counterpart to add()/task(): those hold the loader up, these are the ones
     that must not. Queued rather than fired on a timer so the order is the
     order they were declared in, and scheduled on idle so they never compete
     with the first frame of the revealed page. */
  var deferred = [];
  var flushed = false;

  function runDeferred(fn, label) {
    try {
      var r = fn();
      if (r && typeof r.catch === 'function') {
        r.catch(function (err) { console.warn('[czard-boot] "' + label + '" failed:', err); });
      }
    } catch (err) {
      console.warn('[czard-boot] "' + label + '" threw:', err);
    }
  }

  function defer(fn, label) {
    if (typeof fn !== 'function') return;
    if (flushed) { runDeferred(fn, label || 'deferred'); return; }   // registered late — just go
    deferred.push({ fn: fn, label: label || 'deferred' });
  }

  function flush() {
    if (flushed) return;
    flushed = true;
    var run = function () {
      for (var i = 0; i < deferred.length; i++) runDeferred(deferred[i].fn, deferred[i].label);
      deferred.length = 0;
    };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2000 });
    else setTimeout(run, 200);
  }

  function seal() { sealed = true; }

  function ready() {
    seal();
    var soft = Promise.all(pending.slice());
    var strict = Promise.all(strictPending.slice());
    var ceiling = new Promise(function (resolve) {
      setTimeout(function () {
        if (settled < total) {
          console.warn('[czard-boot] global timeout — releasing the soft tasks with ' + settled + '/' + total + ' ready');
        }
        resolve();
      }, GLOBAL_TIMEOUT);
    });
    return Promise.all([Promise.race([soft, ceiling]), strict]).then(function () {
      lastProgress = 1;
      flush();          // phase two starts the moment phase one is done
    });
  }

  window.CzardBoot = {
    add: add,
    task: task,
    defer: defer,
    flush: flush,
    ready: ready,
    seal: seal,
    progress: progress,
    stats: function () { return { total: total, settled: settled, sealed: sealed }; }
  };
})();
